<template>
  <div class="control-device">
    <base-button class="control-device__btn" @click="clearCache">Clear cache</base-button>
    <base-button class="control-device__btn" @click="restart">Restart</base-button>
  </div>
</template>

<script>
import BaseButton from '@/components/common/BaseButton.vue'
import devicesService from '@/services/devices.js'

export default {
 name: 'ControlDEvice',
 components: { BaseButton },
 props: {
   idDevice: {
     type: String,
     required: true
   }
 },
 methods: {
   async clearCache() {
     await devicesService.commandDevice('clear', this.idDevice)
   },
   async restart() {
     await devicesService.commandDevice('restart', this.idDevice)
   }
 }

}
</script>

<style>
  .control-device {
    display: flex;
  }

  .control-device__btn {
    margin-right: 15px;
  }

</style>